/**
 * NAD3-30 Live Orders Popup - JavaScript
 */

// Array of sample orders for NAD3-30
const orders = [
    { name: "Guadalupe", location: "CA", product: "NAD3 30 1 Bottle", time: "13 minutes ago" },
    { name: "Phyllis", location: "OH", product: "NAD3 30 4 Bottles", time: "29 minutes ago" },
    { name: "Hayley", location: "FL", product: "NAD3 30 1 Bottle", time: "44 minutes ago" },
    { name: "Patrice", location: "SC", product: "NAD3 30 1 Bottle", time: "1 hour 2 minutes ago" },
    { name: "Darren", location: "CT", product: "NAD3 30 1 Bottle", time: "1 hour 20 minutes ago" },
    { name: "Yerikza", location: "FL", product: "NAD3 30 1 Bottle", time: "1 hour 39 minutes ago" },
    { name: "Renalle", location: "NE", product: "NAD3 30 2 Bottles", time: "1 hour 58 minutes ago" },
    { name: "Deborah", location: "NC", product: "NAD3 30 1 Bottle", time: "2 hours 18 minutes ago" },
    { name: "Symone", location: "IL", product: "NAD3 30 1 Bottle", time: "2 hours 38 minutes ago" },
    { name: "Jeffrey", location: "AR", product: "NAD3 30 2 Bottles", time: "2 hours 58 minutes ago" },
    { name: "Phillip", location: "ON", product: "NAD3 30 2 Bottles", time: "15 minutes ago" },
    { name: "Deanna", location: "IN", product: "NAD3 30 1 Bottle", time: "31 minutes ago" },
    { name: "Michael", location: "CO", product: "NAD3 30 1 Bottle", time: "46 minutes ago" },
    { name: "Terrael", location: "OK", product: "NAD3 30 1 Bottle", time: "1 hour 3 minutes ago" },
    { name: "Matt", location: "UT", product: "NAD3 30 2 Bottles", time: "1 hour 21 minutes ago" },
    { name: "Bill", location: "OH", product: "NAD3 30 1 Bottle", time: "1 hour 40 minutes ago" },
    { name: "Wesley", location: "TX", product: "NAD3 30 1 Bottle", time: "2 hours 1 minute ago" },
    { name: "Chris", location: "AB", product: "NAD3 30 3 Bottles", time: "2 hours 22 minutes ago" },
    { name: "Kelvin", location: "NV", product: "NAD3 30 1 Bottle", time: "2 hours 44 minutes ago" },
    { name: "Mysti", location: "TX", product: "NAD3 30 1 Bottle", time: "3 hours 6 minutes ago" },
    { name: "Deanna", location: "IN", product: "NAD3 30 1 Bottle", time: "14 minutes ago" },
    { name: "Laura", location: "FL", product: "NAD3 30 1 Bottle", time: "28 minutes ago" },
    { name: "Susan", location: "OH", product: "NAD3 30 1 Bottle", time: "43 minutes ago" },
    { name: "Raquele", location: "NJ", product: "NAD3 30 1 Bottle", time: "58 minutes ago" },
    { name: "Lorenzo", location: "TX", product: "NAD3 30 1 Bottle", time: "1 hour 15 minutes ago" },
    { name: "Jayme", location: "TX", product: "NAD3 30 1 Bottle", time: "1 hour 33 minutes ago" },
    { name: "Desiree", location: "FL", product: "NAD3 30 1 Bottle", time: "1 hour 52 minutes ago" },
    { name: "Rosemarie", location: "AZ", product: "NAD3 30 1 Bottle", time: "2 hours 12 minutes ago" },
    { name: "Brandon", location: "NC", product: "NAD3 30 1 Bottle", time: "2 hours 33 minutes ago" },
    { name: "Phyllis", location: "OH", product: "NAD3 30 4 Bottles", time: "2 hours 55 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_15_Day_Supply_Zoom.png?v=1733446935" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
